(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sbs-brand-tabs"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root._sbsTabs) return;
      root._sbsTabs = true;
      var q = new URLSearchParams(location.search);
      var on = root.getAttribute('data-mode') === 'on';
      if (!on) {
        try {
          if (q.get('tabs') === '1') sessionStorage.setItem('sbsTabs', '1');
          if (q.get('tabs') === '0') sessionStorage.removeItem('sbsTabs');
          on = sessionStorage.getItem('sbsTabs') === '1';
        } catch (e) {
          on = q.get('tabs') === '1';
        }
      }
      if (!on) return;
      root.hidden = false;
      var mine = root.closest('.shopify-section') || root;
      var shelves = document.querySelector('.shopify-section[id$="__shelves"]');
      var list = document.querySelector('.shopify-section[id$="__main"]');
      if (!list) return;
      var hasRows = !!(shelves && shelves.querySelector('.sbs-shelf'));
      var heading = document.createElement('h2');
      heading.className = 'page-width sbs-tabs__alt';
      heading.textContent = root.getAttribute('data-heading') || '';

      function set(tab, scroll) {
        var all = tab === 'all';
        root.querySelectorAll('[data-tab]').forEach(function (b) {
          var is = b.getAttribute('data-tab') === tab;
          b.classList.toggle('is-on', is);
          b.setAttribute('aria-selected', is ? 'true' : 'false');
        });
        /* All pieces: the list first, the rows below. Overview: the rows first, the list below. */
        var a = shelves && !all ? shelves : list;
        var b2 = shelves && !all ? list : shelves;
        mine.parentNode.insertBefore(a, mine.nextSibling);
        if (b2) mine.parentNode.insertBefore(b2, a.nextSibling);
        if (all && hasRows) shelves.insertBefore(heading, shelves.firstChild);
        else if (heading.parentNode) heading.parentNode.removeChild(heading);
        document.documentElement.classList.toggle('sbs-tab-all', all);
        if (scroll) {
          /* the bar can be stuck at the top (sticky): measure where it sits in the page, from the section above it */
          var prev = mine.previousElementSibling;
          var top = prev ? prev.getBoundingClientRect().bottom + window.scrollY : root.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: top - 8, behavior: 'instant' });
        }
      }

      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab]');
        if (!b) return;
        var tab = b.getAttribute('data-tab');
        /* with a filter on, the rows are not on the page: Overview opens the brand page without filters */
        if (tab === 'overview' && !hasRows) {
          location.href = root.getAttribute('data-clean-url');
          return;
        }
        set(tab, true);
      });

      /* links to the full list on this same page open the All pieces tab */
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href*="#sbs-all"]');
        if (!a) return;
        var u = new URL(a.getAttribute('href'), location.href);
        if (u.pathname === location.pathname && u.search === location.search) {
          e.preventDefault();
          set('all', true);
        }
      });

      var jump = location.hash === '#sbs-all' || location.hash === '#all';
      var start = root.getAttribute('data-landing') !== 'true' || jump ? 'all' : 'overview';
      set(start, jump);
      if (jump) {
        /* the browser jumps to the #sbs-all anchor on its own, sometimes late: land on the tabs again after it */
        setTimeout(function () { set(start, true); }, 300);
        window.addEventListener('load', function () { setTimeout(function () { set(start, true); }, 60); });
      }
    }
    function run() {
      document.querySelectorAll('[data-sbs-tabs]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-designer"]) return;
  try {
    
  (function () {
    function load(box) {
      if (box._sbs) return;
      box._sbs = true;
      fetch(box.getAttribute('data-src'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var grid = tmp.querySelector('.sbs-ds__grid');
          if (grid && grid.querySelector('li')) {
            box.appendChild(grid);
          } else {
            // no pieces through the tag (UNC pieces have no designer tags): no empty heading
            var h2 = box.parentNode.querySelector('[data-sbs-designer-h2]');
            if (h2) h2.hidden = true;
          }
        });
    }
    function more(bio) {
      var btn = bio.nextElementSibling;
      if (!btn || !btn.classList.contains('sbs-ds__more')) return;
      function check() {
        if (bio.classList.contains('is-open')) return;
        btn.hidden = bio.scrollHeight <= bio.clientHeight + 2;
      }
      if (!bio._sbs) {
        bio._sbs = true;
        btn.addEventListener('click', function () {
          var open = bio.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = btn.getAttribute(open ? 'data-less' : 'data-more');
        });
        window.addEventListener('resize', check);
      }
      check();
    }
    function brands(row) {
      // phones: one line; with more brands than fit, the row scrolls sideways and fades out on the right
      function check() {
        row.classList.toggle('is-scroll', row.scrollWidth > row.clientWidth + 1);
        row.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
      }
      if (!row._sbs) {
        row._sbs = true;
        row.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check);
      }
      check();
    }
    function run() {
      document.querySelectorAll('[data-sbs-designer-grid]').forEach(load);
      document.querySelectorAll('[data-sbs-bio]').forEach(more);
      document.querySelectorAll('.sbs-ds__brands').forEach(brands);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
